<div
  class="layout"
  [class.layout--collapsed]="isMenuCollapsed()"
>
  <div class="layout__side-bar">
    <div
      class="layout__logo"
      (click)="navigateToMainPage()"
    >
      <img
        [src]="`assets/images/${isMenuCollapsed() ? 'collapsed-' : ''}logo.svg`"
        alt="logo"
      />
    </div>
    <div class="layout__menu">
      <lib-menu
        [compact]="isMenuCollapsed()"
        [items]="menuItems()"
        buttonStyle="transparent"
      />
    </div>

    <div class="layout__account">
      <mon-account [collapsed]="isMenuCollapsed()" />
    </div>

    <div class="layout__footer">
      <button
        class="layout__toggle"
        type="button"
        (click)="toggleSidebar()"
        [attr.aria-expanded]="!isMenuCollapsed()"
      >
        <lib-svg-icon
          class="layout__toggle-icon"
          icon="arrow-left"
          [size]="24"
        />
        <span class="layout__toggle-label">
          {{ 'monitoring.hide-sidebar' | translate }}
        </span>
      </button>
    </div>
  </div>

  <div class="layout__content">
    <router-outlet />
  </div>
</div>
